module.exports = __webpack_public_path__ + "static/img/gd-07.ff61085a.jpg";